<p
  [matTooltip]="tooltipText ? getTooltipTranslation() : ''"
  matTooltipClass="label-tooltip"
  [class.has-tooltip]="tooltipText"
>
  {{ processTranslation(text) }}
</p>